<template>
  <iText v-if="editMode" variant="subtle">
    Returns the fan to where they came from after {{ redirectDelaySeconds }}s
  </iText>
</template>

<script>
import {
  CurrentSubscriptionElementMixin,
} from "%/dynamic-component-editor/standard-components/current-subscription/current-subscription-element-mixin";
import RedirectDelaySeconds from "%/dynamic-component-editor/options/redirect-delay-seconds";

const REDIRECT_QUERY_PARAM = "redirect";
const DEFAULT_DELAY_SECONDS = 3;

export default {
  name: "CurrentSubscriptionReturnRedirect",
  elementPanelSettings: {
    displayName: "Return To Previous Page",
    displayIcon: "arrow-left",
    elementGroup: "currentSubscriptionElements",
    elementType: "element",
  },
  mixins: [CurrentSubscriptionElementMixin],
  options: [RedirectDelaySeconds],
  data() {
    return {
      RedirectDelaySeconds,
      redirectTimeoutId: null,
    };
  },
  computed: {
    redirectDelaySeconds() {
      const configured = Number(this.getOptionValue(RedirectDelaySeconds));
      if (Number.isFinite(configured) && configured >= 0) {
        return configured;
      }
      return DEFAULT_DELAY_SECONDS;
    },
    // Only a URL on this origin is followed. The value arrives as a query
    // parameter, so anything else would turn a checkout return into an open
    // redirect to a site the destination does not control.
    returnUrl() {
      const raw = new URLSearchParams(window.location.search).get(REDIRECT_QUERY_PARAM);
      if (!raw) {
        return "";
      }
      let resolved = null;
      try {
        resolved = new URL(raw, window.location.origin);
      } catch (error) {
        return "";
      }
      if (resolved.origin !== window.location.origin) {
        return "";
      }
      return resolved.href;
    },
  },
  mounted() {
    if (this.editMode || !this.returnUrl) {
      return;
    }
    this.redirectTimeoutId = setTimeout(() => {
      window.location.href = this.returnUrl;
    }, this.redirectDelaySeconds * 1000);
  },
  beforeUnmount() {
    if (this.redirectTimeoutId) {
      clearTimeout(this.redirectTimeoutId);
    }
  },
};
</script>
